import electionService from '@/services/election.service';
import moment from 'moment';
import store from '..';
import { convertBool } from '@/utils/util.js';

const state = {
  city: null,
  createdOn: null,
  electionLogo: '',
  id: null,
  name: null,
  reports: null,
  secretaryLogo: null,
  secretaryName: null,
  state: null,
  typeBallotBox: null,
  uf: null,
  updatedOn: null,
  votesPerVoter: null,
  voting: null,
  currentState: null,
  dateElectionOk: false,
  electionDateEnd: null,
  electionDateStart: null,
  stateElectionOk: false,
  electionList: null,
  loginPersonalData: false,
  loginAzureAd: false,
  candidateRolesArray: null,
  Mosaico: false,
  candidateSize: null,
  electionMessage: null,
  physicalKeyboard: false,
  votingTime: false,
  votingTimeValue: 300000,
  receiptTime: false,
  receiptTimeValue: 5000,
  confirmRecaptcha: false,
  resetPassword: false,
  candidate_roles_total: 0
};

const mutations = {
  get: (state, payload) => {
    state.city = payload.city;
    state.createdOn = payload.created_on;
    state.electionLogo = payload.electionLogo;
    state.id = payload.id;
    state.name = payload.name;
    state.reports = payload.reports;
    state.secretaryLogo = payload.secretaryLogo;
    state.secretaryName = payload.secretaryName;
    state.state = payload.state;
    state.typeBallotBox = payload.typeBallotBox;
    state.uf = payload.uf;
    state.updatedOn = payload.updated_on;
    state.votesPerVoter = payload.votesPerVoter;
    state.candidateSize = payload.candidateSize;
    state.electionMessage = payload.electionMessage;
    state.voting = payload.voting;
    state.electionDate = moment
      .unix(payload.electionDate || new Date())
      .format('DD/MM/YYYY');
    state.periodStart = payload.periodStart;
    state.periodEnd = payload.periodEnd;
    state.loginPersonalData = (payload.loginPersonalData.toString().toUpperCase() === 'TRUE');
    state.loginAzureAd = (payload.loginAzureAd.toString().toUpperCase() === 'TRUE');
    state.Mosaico = payload.mosaic_urn;
    if (payload.candidateRolesList && payload.candidateRolesList.length > 0) {
      state.candidateRolesArray = payload.candidateRolesList;
      state.candidate_roles_total = payload.candidateRolesList.length;
    }
    state.physicalKeyboard = (payload.physical_keyboard.toString().toUpperCase() === 'TRUE');
    state.votingTime = (payload.voting_time.toString().toUpperCase() === 'TRUE');
    state.votingTimeValue = payload.voting_time_value;
    state.receiptTime = (payload.receipt_time.toString().toUpperCase() === 'TRUE');
    state.receiptTimeValue = payload.receipt_time_value;
    state.confirmRecaptcha = (payload.confirmRecaptcha.toString().toUpperCase() === 'TRUE');
    state.resetPassword = convertBool(payload.resetPassword.toString());
  },
  electionCommitAccess: (state, payload) => {
    state.city = payload.city;
    state.currentState = payload.currentState;
    state.dateElectionOk = payload.dateElectionOk;
    state.electionDateEnd = payload.electionDateEnd;
    state.electionDateStart = payload.electionDateStart;
    state.id = payload.id;
    state.name = payload.name;
    state.secretaryName = payload.secretaryName;
    state.stateElectionOk = payload.stateElectionOk;
    state.typeballotbox = payload.typeballotbox;
    state.votesPerVoter = payload.votesPerVoter;
    state.candidateSize = payload.candidateSize;
    state.electionMessage = payload.electionMessage;
    state.voting = payload.voting;
    state.loginPersonalData = payload.loginPersonalData;
    state.loginAzureAd = payload.loginAzureAd;
    state.Mosaico = payload.mosaic_urn;
    state.physicalKeyboard = (payload.physical_keyboard.toString().toUpperCase() === 'TRUE');
    state.votingTime = (payload.voting_time.toString().toUpperCase() === 'TRUE');
    state.votingTimeValue = payload.voting_time_value;
    state.receiptTime = (payload.receipt_time.toString().toUpperCase() === 'TRUE');
    state.receiptTimeValue = payload.receipt_time_value;
    state.confirmRecaptcha = (payload.confirmRecaptcha.toString().toUpperCase() === 'TRUE');
    state.resetPassword = convertBool(payload.resetPassword.toString());
    state.candidate_roles_total = payload.candidate_roles_total;
  },
  electionCommitList: (state, payload) => {
    state.electionList = payload;
  },
  clearElection: (state, payload) => {
    state.id = payload;
  }
};

const getters = {
  mySelf: state => {
    return { ...state };
  }
};

const actions = {
  get: async ({ commit }, { idElection }) => {
    const result = await electionService.get(idElection);
    commit('get', result.data);
  },

  getElections: async ({ commit }, { idElection }) => {
    const result = await electionService.getElections(idElection);

    if (Array.isArray(result.data)) {
      commit('electionCommitList', result.data);
    } else if (result.data !== undefined) {
      commit('electionCommitAccess', result.data);
    }
  },

  verifyElectionAccess: async ({ commit }, { urlAccessKey }) => {
    const result = await electionService.validateElectionAcess(urlAccessKey);
    if (Array.isArray(result.data)) {
      commit('electionCommitList', result.data);
    } else {
      commit('electionCommitAccess', result.data);
    }
  },
  validateElectionAccess: async ({ commit }, { idElection, accessKey }) => {
    const result = await electionService.accessElectionKey(idElection, accessKey);
    if (result.status === 'ok') {
      await store.dispatch('voter/loadVoter', { voterJson: result.data.voter });
      await store.dispatch('login/loadIdentifier', { voterJson: result.data.voter });
      commit('electionCommitAccess', result.data.election);
    }
  },
  clearElection: async ({ commit }, { param }) => {
    commit('clearElection', param);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
